import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { VerificationCode } from '../model/user.model';
import { EventManager } from '../service/event-manager.service';
import { OAuthSocialUser } from './oauth-user.model';
import { PrincipalService } from './principal.service';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
    constructor(
        private http: HttpClient,
        private principal: PrincipalService,
        private em: EventManager
    ) {}

    login(credentials): Observable<any> {
        const data = {
            username: credentials.username,
            password: credentials.password,
            rememberMe: credentials.rememberMe,
        };
        return this.http.post('/auth/login', data, {});
    }

    verifyCode(code: VerificationCode): Observable<any> {
        return this.http.post<any>('/auth/twofa-verify', code, {});
    }

    reSendVerifyCode(code: VerificationCode): Observable<any> {
        return this.http.post<any>('/auth/resend-verify-code', code, {});
    }

    logout(): Observable<any> {
        return this.http.post('/auth/logout', null);
    }

    changeConnectionStatus(
        userId: string,
        id: string,
        type: 'student' | 'teacher' | 'parent' | 'user',
        isConnected: boolean
    ): Observable<any> {
        return this.http.get(`/auth/connection-status-change/${userId}/${id}/${type}/${isConnected}`, {});
    }

    async refreshToken(): Promise<void> {
        try {
            const response = await firstValueFrom(
                this.http.post<any>(`/auth/refresh-token`, {}, { observe: 'response' })
            );

            if (response?.body?.access_token) {
                this.principal.accessToken = response.body.access_token;
                return Promise.resolve();
            } else {
                throw new Error('No access token in response');
            }
        } catch (error) {
            console.error('Token refresh failed:', error);
            this.principal.closeSession();
            this.em.broadcast({
                name: 'show-login',
                content: {},
            });
            return Promise.reject(error);
        }
    }

    loginViaSocial(token: OAuthSocialUser): Observable<any> {
        return this.http.post('/auth/login-social', token, {});
    }
}
